import { z } from 'zod';
import { authenticatedAPI } from '../AuthenticatedAPI';
import { voucherStateResDto } from '@web/common';

export const getVoucherStates = async () => {
  return authenticatedAPI.get(
    'api/voucher-allowance/state',
    voucherStateResDto,
  );
};

export const redeemVoucher = async (allowanceId: number) => {
  return authenticatedAPI.post(
    `api/voucher-allowance/${allowanceId}/redeem`,
    undefined,
    z.string(),
  );
};
